"use strict";

(function ($) {
  $.fn.showTel = function () {
    var $that = $(this),
        numbers = $that.data('numbers').split(','),
        labels = $that.data('labels').split(',');

    for (var i = 0; i < numbers.length; i++) {
      numbers[i] = '<li class="js-call' + (i > 0 ? ' mts' : '') + '"><a class="Btn Btn--block Btn--modal Btn--gradient-primary">' + labels[i] + ': ' + numbers[i] + '</a></li>';
    }

    $that.on('click', function (e) {
      var $that = $(this);
      $(this).next('.js-showed-tel').html(numbers).removeClass('hide');
      $('.js-call').on('click', function (e) {
        var number = $(this).text();
        $(this).find('a').attr('href', 'tel:' + number);
        $(this).removeClass('js-call');
      });
      $that.addClass('hide');
    });
  };
})(jQuery);

function clearTel() {
  if ($('.js-show-tel').length) {
    var $button = $('.js-show-tel'),
        $list = $('.js-showed-tel');
    $button.removeClass('hide');
    $list.addClass('hide');
  }
}

function initTel(elem) {
  if (elem.find('.js-show-tel').length) {
    elem.find('.js-show-tel').showTel();
  }
}